export default __webpack_public_path__ + "static/media/youtube.697f60ac.svg";